import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'voice-reports',
  templateUrl: './voice-reports.component.html',
  styleUrls: ['./voice-reports.component.scss']
})
export class VoiceReportsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
